import { Icon as ChakraIcon, Flex, type IconProps } from "@chakra-ui/react";

import {
  Alert,
  ArrowTop,
  ArrowsExchange,
  Camera,
  CardFill,
  CellChevronForward,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleCheck,
  CirclePlus,
  ClipboardText,
  Clock,
  ClockFill,
  ClockLine,
  ClockLineFill,
  Copy,
  CryptoBTC,
  CryptoETH,
  CryptoOther,
  CryptoTON,
  CryptoTRC,
  CryptoUSDT,
  CurrencyKGS,
  CurrencyRUB,
  CurrencyUSD,
  Details,
  Doc,
  Dollar,
  Download,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileText,
  FileVariant,
  Gift,
  Home,
  HomeFill,
  IdentificationBadge,
  Info,
  InfoCircle,
  InfoCircleFill,
  Key,
  Language,
  Limit,
  Lock,
  LogOut,
  NumberCircle1,
  NumberCircle2,
  NumberCircle3,
  NumberCircle4,
  NumberCircle5,
  PaperPlane,
  Pause,
  PaymentElqr,
  PaymentSbp,
  PaymentVtbQr,
  Pencil,
  Phone,
  Plus,
  Profile,
  ProfileFill,
  QR,
  QrLogo,
  Question,
  ScanSmiley,
  Settings,
  Shield,
  ShieldDone,
  Sun,
  Support,
  Swap,
  SwapAlt,
  TgLogo,
  Trash,
  UnknownNetwork,
  Verify,
  Wallet,
  WalletFill,
  World,
  XClose,
} from "../../../assets/icons";

export const icons = {
  Alert,
  ArrowTop,
  ArrowsExchange,
  Camera,
  CardFill,
  CellChevronForward,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleCheck,
  CirclePlus,
  ClipboardText,
  Clock,
  ClockFill,
  ClockLine,
  ClockLineFill,
  Copy,
  CryptoBTC,
  CryptoETH,
  CryptoOther,
  CryptoTON,
  CryptoTRC,
  CryptoUSDT,
  CurrencyKGS,
  CurrencyRUB,
  CurrencyUSD,
  Details,
  Doc,
  Dollar,
  Download,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileText,
  FileVariant,
  Gift,
  Home,
  HomeFill,
  IdentificationBadge,
  Info,
  InfoCircle,
  InfoCircleFill,
  Key,
  Language,
  Limit,
  Lock,
  LogOut,
  NumberCircle1,
  NumberCircle2,
  NumberCircle3,
  NumberCircle4,
  NumberCircle5,
  PaperPlane,
  Pause,
  PaymentElqr,
  PaymentSbp,
  PaymentVtbQr,
  Pencil,
  Phone,
  Plus,
  Profile,
  ProfileFill,
  QR,
  QrLogo,
  Question,
  ScanSmiley,
  Settings,
  Shield,
  ShieldDone,
  Sun,
  Support,
  Swap,
  SwapAlt,
  TgLogo,
  Trash,
  UnknownNetwork,
  Verify,
  Wallet,
  WalletFill,
  World,
  XClose,
} as const;

export type AppIconName = keyof typeof icons;

type AppIconProps = {
  name: AppIconName;
  variant?: "default" | "frame";
} & IconProps;

const pMap: Record<string, AppIconProps["p"]> = {
  "2xl": "6",
  "2xs": "2",
  inherit: "inherit",
  lg: "2",
  md: "2",
  sm: "2",
  xl: "4",
  xs: "2",
};

export function Icon({
  bg,
  borderRadius,
  name,
  p,
  size = "lg",
  variant = "default",
  ...props
}: AppIconProps) {
  const Component = icons[name];
  return (
    <Flex
      bg={variant === "frame" ? bg || undefined : bg}
      borderRadius={variant === "frame" ? borderRadius || "full" : borderRadius}
      p={variant === "frame" ? p || pMap[size as string] : p}
    >
      <ChakraIcon size={size} {...props}>
        <Component />
      </ChakraIcon>
    </Flex>
  );
}
